import { Pipe, PipeTransform } from '@angular/core';
import { DirectPropertyCheck } from '@app/shared/services/properties/properties.service';

@Pipe({
  standalone: false,
  name: 'ignorePropertyChecks',
})
export class IgnorePropertyChecksPipe implements PipeTransform {
  transform(propertyChecks: DirectPropertyCheck[], removeIdKeys: string[]): DirectPropertyCheck[] {
    return propertyChecks.filter((propertyCheck) => {
      return !removeIdKeys.includes(propertyCheck.id);
    });
  }
}
